import { CurrencyPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import CustomizacaoParcelamento from 'src/app/shared/models/customizacao-parcelamento.model';
import { NovoPlanoRenegociacao } from 'src/app/shared/models/novo-plano-renegociacao.model';
import DateUtils from 'src/app/shared/utils/date-utils';

@Component({
  selector: 'app-renegociacao-planos-parcelamento',
  templateUrl: './renegociacao-planos-parcelamento.component.html',
  styleUrls: ['./renegociacao-planos-parcelamento.component.scss']
})
export class RenegociacaoPlanosParcelamentoComponent implements OnInit, OnDestroy {

  @Input()
  planos: NovoPlanoRenegociacao[] = [];

  customizacaoParcelamento: CustomizacaoParcelamento = new CustomizacaoParcelamento();

  selectPlanoModelChanged = new Subject<string>();

  planoSelecioando: NovoPlanoRenegociacao;

  loginComColaborador = this.autenticacaoService.colaboradorAutenticado;

  @Output()
  recalcularPlanos: EventEmitter<CustomizacaoParcelamento> = new EventEmitter<CustomizacaoParcelamento>();

  @Output()
  selecionarPlano: EventEmitter<NovoPlanoRenegociacao> = new EventEmitter<NovoPlanoRenegociacao>();

  constructor(
    private currencyPipe: CurrencyPipe,
    private autenticacaoService: AutenticacaoService,
  ) { }

  ngOnInit(): void {
    this.customizacaoParcelamento.valorEntrada = this.planoReferencia.valorEntrada;
    this.customizacaoParcelamento.dataVencimento = this.dataMaximaEntrada;
    this.selectPlanoModelChanged.pipe(debounceTime(500)).subscribe(() => this.emitRecalcularPlano());
  }

  ngOnDestroy(): void {
    this.selectPlanoModelChanged.unsubscribe();
  }

  get planoReferencia(): NovoPlanoRenegociacao {
    return this.planos[0];
  }

  get valorMinimoEntrada(): number {
    return this.planoReferencia.informacoesComplementares.valorMinimoEntrada;
  }

  get valorMaximoEntrada(): number {
    return this.planoReferencia.informacoesComplementares.valorMaximoEntrada;
  }

  get dataMinimaEntrada(): Date {
    return DateUtils.normalizedDate(this.planoReferencia.informacoesComplementares.dataMinimoEntrada as string);
  }

  get dataMaximaEntrada(): Date {
    return DateUtils.normalizedDate(this.planoReferencia.informacoesComplementares.dataMaximoEntrada as string);
  }

  emitRecalcularPlano(): void {
    if (this.customizacaoParcelamento.valorEntrada < this.valorMinimoEntrada) {
      return;
    }

    if (this.customizacaoParcelamento.valorEntrada > this.valorMaximoEntrada) {
      return;
    }

    this.recalcularPlanos.emit(this.customizacaoParcelamento);
    this.planoSelecioando = null;
  }

  emitSelecionarPlano(planoSelecionado: NovoPlanoRenegociacao): void {
    this.selecionarPlano.emit(planoSelecionado);
  }

  getSelectPlanoLabel(plano: NovoPlanoRenegociacao): string {
    return `${this.currencyPipe.transform(plano.valorEntrada, 'BRL')} + ${plano.parcelas}x  ${this.currencyPipe.transform(plano.valor, 'BRL')}`;
  }

}
